/**
 * Query Status Constants
 * Status definitions and styling for queries
 */

export const QUERY_STATUS = {
  PENDING_INITIAL_CALCULATION: 'pending_initial_calculation',
  PENDING_INITIAL_APPROVAL: 'pending_initial_approval',
  PENDING_INSPECTION_PAYMENT: 'pending_inspection_payment',
  PENDING_AGENT: 'pending_agent',
  PENDING_OWNER_APPROVAL: 'pending_owner_approval',
  PENDING_INVESTOR: 'pending_investor',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const QUERY_STATUS_COLORS = {
  [QUERY_STATUS.PENDING_INITIAL_CALCULATION]: "bg-cyan-100 text-cyan-800",
  [QUERY_STATUS.PENDING_INITIAL_APPROVAL]: "bg-sky-100 text-sky-800",
  [QUERY_STATUS.PENDING_INSPECTION_PAYMENT]: "bg-yellow-100 text-yellow-800",
  [QUERY_STATUS.PENDING_AGENT]: "bg-blue-100 text-blue-800",
  [QUERY_STATUS.PENDING_OWNER_APPROVAL]: "bg-purple-100 text-purple-800",
  [QUERY_STATUS.PENDING_INVESTOR]: "bg-orange-100 text-orange-800",
  [QUERY_STATUS.ACTIVE]: "bg-green-100 text-green-800",
  [QUERY_STATUS.COMPLETED]: "bg-gray-100 text-gray-800",
  [QUERY_STATUS.CANCELLED]: "bg-red-100 text-red-800",
};

export const QUERY_STATUS_LABELS = {
  [QUERY_STATUS.PENDING_INITIAL_CALCULATION]: "Pending Initial Calculation",
  [QUERY_STATUS.PENDING_INITIAL_APPROVAL]: "Pending Initial Approval",
  [QUERY_STATUS.PENDING_INSPECTION_PAYMENT]: "Pending Inspection Payment",
  [QUERY_STATUS.PENDING_AGENT]: "Pending Agent",
  [QUERY_STATUS.PENDING_OWNER_APPROVAL]: "Pending Owner Approval",
  [QUERY_STATUS.PENDING_INVESTOR]: "Pending Investor",
  [QUERY_STATUS.ACTIVE]: "Active",
  [QUERY_STATUS.COMPLETED]: "Completed",
  [QUERY_STATUS.CANCELLED]: "Cancelled",
};

